import { cva } from "class-variance-authority";

export const registerFeedbackPageStyles = cva([
  "box-border flex w-full min-w-0 max-w-full flex-col",
  "lg:bg-white lg:flex-1 lg:w-full lg:min-h-full",
]);

/** Thank-you route is excluded from auth-container-feedback-flow — no lg:bg-white override. */
export const registerFeedbackThankYouPageStyles = cva([
  "box-border flex w-full min-w-0 max-w-full flex-col",
]);

export const registerFeedbackContentStyles = cva([
  "mx-auto box-border flex w-full min-w-0 max-w-[760px] flex-col items-stretch px-4 pb-8 pt-6",
  "md:max-w-[402px] md:mx-auto",
  "lg:max-w-[760px] lg:items-center lg:pt-10",
]);

export const registerFeedbackThankYouContentStyles = cva([
  "mx-auto box-border flex w-full min-w-0 max-w-full flex-col items-stretch overflow-x-hidden px-4 pb-8 pt-6",
  "md:items-center md:px-8 md:pt-10",
]);
